import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslation } from 'react-i18next';

function ConfirmationDialog(props) {
    const {
        onAccept,
        onCancel,
        open,
        children,
        title,
        closeOnly = false,
    } = props;
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onCancel}>
            {title && <DialogTitle>{title}</DialogTitle>}
            <DialogContent>
                {children}
                {/* <DialogContentText id="alert-dialog-description">
          Let Google help apps determine location. This means sending anonymous location data to
          Google, even when no apps are running.
        </DialogContentText> */}
            </DialogContent>
            <DialogActions>
                {closeOnly ? (
                    <Button onClick={onCancel} color="primary" autoFocus>
                        {t('buttons.close')}
                    </Button>
                ) : (
                    <>
                        <Button onClick={onAccept} color="primary">
                            OK
                        </Button>
                        <Button onClick={onCancel} color="secondary" autoFocus>
                            {t('buttons.cancel')}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}

ConfirmationDialog.propTypes = {
    onAccept: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default ConfirmationDialog;
